module.exports = __webpack_public_path__ + "static/media/TableCorner_Before.283e3649.jpg";